var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4 mb-4"},[_c('p',{staticClass:"secondary--text text-h6"},[_vm._v("Observaciones")]),_c('app-rich-text-component',{model:{value:(_vm.observaciones),callback:function ($$v) {_vm.observaciones=$$v},expression:"observaciones"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }